import { render, staticRenderFns } from "./RoleContainer.vue?vue&type=template&id=228ae2a6&scoped=true&"
import script from "./RoleContainer.vue?vue&type=script&lang=js&"
export * from "./RoleContainer.vue?vue&type=script&lang=js&"
import style0 from "./RoleContainer.vue?vue&type=style&index=0&id=228ae2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ae2a6",
  null
  
)

export default component.exports